let counter = 1;

document.querySelectorAll('section').forEach((section) => {
    if (!section.classList.contains('content-title')) {
        section.id = `section-${counter}`;
        counter++;
    }
});
